import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
const FormsSlice = createSlice({
    name: 'forms',
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { id, ...rest } = action.payload;
            if (!state[id]) {
                state[id] = {};
            }
            Object.keys(rest).forEach((k) => {
                const v = rest[k];
                state[id][k] = v;
            });
        },
        resetFormWithId: (state, action) => {
            const formId = action.payload;
            if (state[formId]) {
                delete state[formId];
            }
        },
    },
});
export const FormsActions = {
    ...FormsSlice.actions,
};
export const FormsReducer = FormsSlice.reducer;
